export default __webpack_public_path__ + "static/media/contact-us.344aa7d1.jpg";